export const downloadUrl = (url, name = 'download') => {
    let a = document.createElement('a');
    a.href = url;
    a.download = name;
    a.click();
}